import { Box, Grid, Skeleton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import CardFrom, { CardFormConfig } from '../../../component/card/card-from';
import i18n from 'i18next';
import { Staff } from '../../../models/staff.entity';
import { useManualRemove } from '../../mobx-objs/mobx-manager';
import { GroupAccountState } from './group-account-state';
// scss
import './scss/group-account.style.scss';
import ButtonComponent from '../../../component/button/button.component';
import { useTranslation } from 'react-i18next';
import CardView from '../../../component/card/card-view';
import BindAccount from '../../../component/bind-account/bind-account.component';
import { TableRowFeatures } from '../../../component/table/table.component';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';

// 卡片组渲染数据
export const GroupAccountCardArr: CardFormConfig[] = [
    // 主要信息数据
    {
        key: 'main',
        title: 'create_group_component_text_main_information',
        rowSpacing: 6,
        children: [
            {
                comType: 'AVATAR',
                key: 'avatar',
                xs: 12,
            },
            {
                key: 'nickname',
                label: 'group_management_page_text_group_name',
                required: true,
                comType: 'INPUT',
                regularType: 'inputLimit120',
                inputType: 'INPUT',
                xs: 12,
            }
        ]
    },
    // 地址信息数据
    {
        key: 'address',
        title: 'address_component_text_address',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'local',
                label: 'address_component_text_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12,
            },
            {
                key: 'home_number',
                label: 'address_component_text_doorbell',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'postcode',
                label: 'address_component_text_postal_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'city',
                label: 'address_component_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'state',
                label: 'address_component_text_province',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'country',
                label: 'address_component_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
            },
        ]
    },
    // 税务信息表单数据
    {
        key: 'tax',
        title: 'create_group_component_text_tax_information',
        rowSpacing: 6,
        children: [
            {
                key: 'reg_fiscal_code',
                label: 'create_group_component_text_fiscal_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'fiscalCode',
                xs: 12,
            },
            {
                key: 'reg_vat_number',
                label: 'create_group_component_text_vat_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'vatNumber',
                xs: 12,
            },
            {
                key: 'reg_pec',
                label: 'create_group_component_text_recipient_mailbox',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'email',
                xs: 12,
                md: 0,
            },
            {
                key: 'reg_des_code',
                label: 'create_group_component_text_electronic_invoice_recipient_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'recipientCode',
                xs: 12,
            },
        ]
    },
    // 联系方式表单数据
    {
        key: 'contactWay',
        title: 'create_group_component_text_contact',
        rowSpacing: 5,
        columnSpacing: { md: 4 },
        children: [
            {
                key: 'email',
                label: 'general_text_email',
                comType: 'INPUT',
                inputType: 'INPUT',
                regularType: 'email',
                xs: 12,
                md: 12,
            },
            {
                key: 'phone_prefix',
                label: 'general_text_country_code',
                comType: 'INPUT',
                inputType: 'COUNTRY_SELECT',
                xs: 3,
            },
            {
                key: 'tel',
                label: 'create_group_component_text_phone',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'phone',
                xs: 9,
            },
        ]
    },
    // 负责人信息表格
    {
        key: 'tableCom',
        title: 'responsible_person_info_component_responsible_person_info',
        rowSpacing: 6,
        xs: 12,
        md: 12,
        titleTypographyProps: {
            // height: 50
            paddingRight: 10
        },
        children: [
            {
                key: 'table',
                comType: 'TABLE',
                xs: 12,
            }
        ]
    },

];

/**
 * 集团账号信息详情
 */
const GroupAccount = observer((props: AccountProps) => {
    useTranslation();

    const { componentType } = props;
    // 数据管理
    const useMobxData = props.useGroupAccountMobx;

    // 骨架屏控制
    const [skeleton, setSkeleton] = React.useState<boolean>(true);


    React.useEffect(() => {
        initComponent();
        // 卸载
        return () => {
            // MobxObjectsManager.remove(GroupAccountState);
        }
    }, []);

    // 初始化组件
    const initComponent = async () => {
        await useMobxData.init();
        // 关闭骨架屏
        setSkeleton(false);
    }
    // unmount
    useManualRemove(GroupAccountState);

    // 数据
    const {
        // isEnableSkeleton,
        groupEditDetail,
        disabledBtn,
        isEditInput,
        dialogConfig,
        deleteDialogConfig,
        operateMap,
        originGroupData,
        isEmptyVerify
    } = useMobxData;

    // 卡片组渲染数据
    const cardArr: CardFormConfig[] = GroupAccountCardArr.map((parentItem) => {
        let extraParentConfig = {};
        switch (parentItem.key) {
            case 'tableCom':
                extraParentConfig = {
                    hidden: componentType === 'ADD' ? true : false,
                    actionRender: (
                        componentType === 'PREVIEW' ? <></> :
                            <Box sx={{ marginRight: 2 }}>
                                <ButtonComponent
                                    variant='contained'
                                    size='small'
                                    // extraButtonStyle={'iconButton'}
                                    handleClick={async () => {
                                        useMobxData.setDialogConfig({
                                            visible: true,
                                        })
                                    }}
                                    action={'ADD'}
                                    titleText={i18n.t('general_text_new')}
                                />
                            </Box>
                    ),
                }
                break;
            default:
                break;
        }
        return {
            ...parentItem,
            ...extraParentConfig,
            children: parentItem?.children?.map((childrenItem) => {
                let extraConfig = {};
                switch (childrenItem.key) {
                    case 'avatar':
                        extraConfig = {
                            isDisabledUpload: componentType === 'PREVIEW',
                            handleChangeAvatar: ((_avatarUrl: string, file: File) => {
                                return useMobxData.onChangeAvatar(file);
                            })
                        }
                        break;
                    case 'table':
                        extraConfig = {
                            tableConfig: {
                                showChecked: componentType === 'PREVIEW' ? 0 : 1,
                                headCellList:
                                    componentType === 'PREVIEW' ?
                                        [
                                            {
                                                id: '1', label: i18n.t('responsible_person_info_component_text_name'),
                                                renderFunction: (row: Staff) => {
                                                    return <>{row.first_name}{row.last_name}</>
                                                }
                                            },
                                            { id: 'email', label: i18n.t('general_text_email') },
                                            { id: 'phone', label: i18n.t('general_text_phone') },

                                        ]
                                        :
                                        [
                                            {
                                                id: '1', label: i18n.t('responsible_person_info_component_text_name'),
                                                renderFunction: (row: any) => {
                                                    return <>{row.first_name}{row.last_name}</>
                                                }
                                            },
                                            { id: 'email', label: i18n.t('general_text_email') },
                                            {
                                                id: 'phone', label: i18n.t('general_text_phone'),
                                                renderFunction: (row: Staff) => {
                                                    return <>{row?.phone_prefix} {row?.phone}</>
                                                },
                                            },
                                            {
                                                id: '5', label: '',
                                                renderFunction: (row: any ) => {
                                                    return renderFeatures(row   )
                                                }
                                            }
                                        ],
                                list: originGroupData.supervisor || [],
                                handleDeleteAll: async (selected: any) => {
                                    // 请求删除
                                    await useMobxData.handleDeleteBindAccount(selected, true);
                                },
                            }
                        }
                        break;
                    default:
                        break;
                }
                return {
                    ...childrenItem,
                    ...extraConfig,
                    // 非空校验
                    isEmpty: isEmptyVerify,
                    // 编辑禁用
                    disabledInput: componentType === 'PREVIEW' ? true : isEditInput,
                    // 编辑反馈
                    inputIsEdited: operateMap.get(childrenItem.key) !== undefined ? true : false,
                    onChange: (e) => {
                        return useMobxData.handleChangeText(e.target.value, childrenItem.key);
                    },
                    handleChangeCountry: (value) => {
                        console.log(value);
                        return useMobxData.handleChangeText(value, 'phone_prefix');
                    }
                }
            })
        }
    }) as CardFormConfig[];

    // *********************
    // Business Function
    // *********************

    // 功能键
    const renderFeatures = (row: Staff): React.ReactNode => {
        return (
            <TableRowFeatures
                buttons={[
                    {
                        variant: 'contained',
                        color: 'secondary',
                        action: 'DELETE',
                        handleClick: () => {
                            useMobxData.updateDeleteDialogConfig({
                                visible: true,
                                forbidConfirm: 0,
                                title: i18n.t('general_text_tips'),
                                content: i18n.t('general_text_whether_to_delete_the_selection'),
                                handleClick: async () => {
                                    if (row._id) {
                                        // 请求删除
                                        await useMobxData.handleDeleteBindAccount(row, false);
                                    }
                                }
                            })
                        }
                    }
                ]}
            />
        )
    }

    // 渲染按钮组
    const renderActionBtn = () => {
        return (
            <Box className='top-button-group'>
                <ButtonComponent
                    size='small'
                    variant={'contained'}
                    forbidConfirm={disabledBtn}
                    // extraButtonStyle={'button-group'}
                    extraTitleStyle={'button-icon'}
                    titleText={`${i18n.t('general_text_save')}`}
                    action={'SAVE'}
                    handleClick={async () => {
                        // 检查必填项
                        // if (checkNeedInfo()) return;
                        await useMobxData.onSave('EDIT');
                    }}
                />
            </Box>
        )
    }

    return (
        <Box className={'group-account-page '}>
            {/* 骨架屏,排除资源回收站跳转 */}
            {
                skeleton ? (
                    <SkeletonViewComp />
                ) : (
                    <Box className={'contain'}>
                        {
                            // 新增和预览不显示保存按钮
                            ['PREVIEW', 'ADD'].includes(componentType || '') ? null
                                :
                                renderActionBtn()
                        }

                        {/* 卡片grid布局视图 */}
                        <CardFrom
                            config={cardArr}
                            data={groupEditDetail as {} || {}}
                        />
                    </Box>
                )
            }
            {/* 弹窗新增绑定负责人 绑定账号组件 */}
            {
                // 新增不显示
                componentType !== 'ADD' &&
                <BindAccount
                    // 弹窗控制
                    configDialog={{
                        visible: dialogConfig.visible,
                        title: dialogConfig?.title ?? '',
                        onClose: dialogConfig?.onClose
                    }}
                    // 弹窗配置数据
                    dialogConfigData={{
                        type: 'GROUP',
                        groupStringId: useMobxData.belongedGroup ?? '',
                        restaurantStringId: '',
                        bindCallBack: async () => {
                            await useMobxData.getGroupAccountData();
                        }
                    }}
                />
            }

            {/* 是否删除所选择项目 */}
            <DeleteDialogComponent
                {...{
                    title: deleteDialogConfig.title,
                    open: deleteDialogConfig.visible,
                    onCancel: () => {
                        useMobxData.updateDeleteDialogConfig({
                            visible: false,
                            title: '',
                            content: '',
                        });
                    },
                    // 确认删除
                    onConfirm: async () => { await deleteDialogConfig?.handleClick?.(); },
                }}
            />
        </Box>
    )
});

export default GroupAccount;

type AccountProps = {
    // 集团_id
    belongedGroupId?: string;
    // 集团string_id
    belongedGroup?: string;
    // 组件类型  预览模式(用于资源回收站浏览) | 可编辑模式
    componentType?: 'EDIT' | 'PREVIEW' | 'ADD';
    // 数据管理
    useGroupAccountMobx: GroupAccountState;
}

function SkeletonViewComp(): JSX.Element {
    return (
        <Box className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={140} height={140} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={170} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}